import CheckIcon from '@material-ui/icons/Check';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import React from 'react';
import { useTranslator } from '~frontend-common/i18n/translator';
import { Box } from '~ui-kit/components/box/box';
import { Button } from '~ui-kit/components/button/button';
import { styled } from '~ui-kit/styled-components';

interface Props {
  hasMoreResults: boolean;
  disabled: boolean;
  maxReached: boolean;
  onLoad: () => void;
  buttonTitle?: string;
}

export function LoadMoreResults({ hasMoreResults, onLoad, disabled, maxReached, buttonTitle }: Props) {
  const { t } = useTranslator();

  if (!hasMoreResults) {
    return (
      <Container>
        <CheckIcon className="icon" />
        {t('core.components.loadMoreResults.fullyLoaded')}
      </Container>
    );
  }

  if (maxReached) {
    return (
      <Container>
        <ErrorOutlineIcon className="icon" />
        {t('core.components.loadMoreResults.maxRows')}
      </Container>
    );
  }

  return (
    <Container>
      <Button appearance="outlined" disabled={disabled} onClick={onLoad}>
        {buttonTitle || t('core.components.loadMoreResults.loadMore')}
      </Button>
    </Container>
  );
}

const Container = styled(Box).attrs({ width: '100%', justifyContent: 'center' })`
  margin: 15px 0px;
  font-size: 20px;

  .icon {
    margin-right: 10px;
  }
`;
